import {Navigate, Route, Routes} from "react-router-dom";
import AuthEntry from "./auth/authEntry";
import LandingPage from "./landing-page";
import MainEnter from "./main/main";
import BlogRoot from "./landing-page/blogs/blog-root";
import PrivacyPolicy from "./privacy-policy";
import TermsOfUse from "./terms-of-use";

export default function Root({className, ...props}) {


    return (
        <div className={`max-w-[100vw]  ${className}`}>
            <Routes>
                <Route path="/auth/*" element={<AuthEntry/>}/>
                <Route path="/" element={<LandingPage/>}/>
                <Route path="/bought-package/:coupon_id/:user_email" element={<LandingPage/>}/>
                <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                <Route path="/terms-of-use" element={<TermsOfUse/>}/>
                <Route path="/blogs/*" element={<BlogRoot/>}/>
                <Route path="/*" element={<MainEnter/>}/>
                <Route path="*" element={<Navigate to="/auth/login" replace/>}/>
            </Routes>
        </div>

    )
}
